import { render } from "./ConstructivePriceTable.vue?vue&type=template&id=4bf6895b&scoped=true"
import script from "./ConstructivePriceTable.vue?vue&type=script&lang=js"
export * from "./ConstructivePriceTable.vue?vue&type=script&lang=js"

import "./ConstructivePriceTable.vue?vue&type=style&index=0&id=4bf6895b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf6895b"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QIcon});
